import { render, staticRenderFns } from "./EdicionCiudades.vue?vue&type=template&id=5d953520&scoped=true"
import script from "./EdicionCiudades.vue?vue&type=script&lang=js"
export * from "./EdicionCiudades.vue?vue&type=script&lang=js"
import style0 from "./EdicionCiudades.vue?vue&type=style&index=0&id=5d953520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d953520",
  null
  
)

export default component.exports